import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";
const ProtectedRoute = () => {
  let token = Cookies.get("F&ftToken");
  return token ? <Outlet /> : <Navigate to="/" />;
};
export default ProtectedRoute;
